import usePersistStore from '@/zustand-store/persist-config/usePersistStore';

const currentNetwork = usePersistStore.getState().currentNetwork;

export const ENDPOINTS = {
  BACKEND:
    currentNetwork === 'solana'
      ? import.meta.env.VITE_BACKEND_URL
      : import.meta.env.VITE_AGENT_EVM_BACKEND_URL,
  BACKEND_MEME:
    import.meta.env.VITE_BACKEND_MEME_URL || 'https://backend-meme.agents.land',
  BACKEND_AIRDROP:
    import.meta.env.VITE_BACKEND_AIRDROP_URL ||
    'https://airdrop-be-stag.agents.land',
  DISTILL:
    import.meta.env.VITE_DISTILL_BACKEND_URL ||
    'https://api-dev.distilled.ai/distill',
};
